module.exports = "/images/cloud.png?9a3d0e882d51f910223decdb529dcd82";